import Modal from '../common/Modal'

export default function ApproveDocumentModal({
  isOpen,
  onClose,
  onConfirm,
  documentName,
  isLoading = false,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-2">
        {/* Header */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-900">Approve Document</h3>
        </div>

        {/* Content */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <svg
                className="w-6 h-6 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <div>
              <h4 className="text-lg font-medium text-gray-900">Confirm Approval</h4>
              <p className="text-sm text-gray-600">This action cannot be undone</p>
            </div>
          </div>

          <p className="text-gray-700 mb-6">
            Are you sure you want to approve the document <strong>"{documentName}"</strong>? Once
            approved, the document will be marked as verified and the user will be notified.
          </p>
        </div>

        {/* Footer */}
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-gray-700 bg-background border border-gray-300 rounded-md hover:bg-neutral-200-50 transition-colors font-medium"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Approving...
              </div>
            ) : (
              'Approve Document'
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}
